import { createSlice } from "@reduxjs/toolkit";
import { EventsType } from "../Common/Types/types";
import { RootState } from "../Core/Store";

const getInitialState = () => {
  return {
    eventID: 0,
    reportType: "",
    reportStatus: "",
    country: "",
    customerName: "",
    machineSN: "",
    svcCallId: "",
    svcStatus: "",
    faultDescription: "",
    servicePersonnel: "",
    engineer: "",
    created: "",
    modified: "",
    startDate: "",
    workHours: "",
    hasAttachments: false,
  };
};

export const initialState: EventsType = getInitialState();

const EventsSlice = createSlice({
  name: "events",
  initialState,
  reducers: {
    updateEventsParams: (state = initialState, action: any) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

export const { updateEventsParams: updateEventsParams } = EventsSlice.actions;

export const getEventsSelector = (state: RootState) => state.events;

export default EventsSlice.reducer;
